<template>
  <div>
    <populate-form
      collapseStyle="simple"
      formTitle="核銷紀錄查詢"
      fkey="sm01"
      ref="filterForm"
      populateOptionVar="filterOptions"
      formDataObjVar="filterData"
      @customValueChanged="optionValueChanged"
    ></populate-form>
    <div class="wrapper2" ref="wrapper" @scroll="handleScroll">
      <b-table ref="scrollarea" striped stacked="sm" hover :items="QueryExecutionListResult" :fields="fields" @scrolldownend="loadExecutionList(true)">
        <template v-slot:cell(actions)="row">
          <star-rating
            v-if="$bus.getRole()=='merchant' && !$bus.session.is_super_manage && (row.item.still_can_score || row.item.store_score > 0) "
            v-model="row.item.store_score"
            :starSize=20
            :read-only="!row.item.still_can_score||row.item.ticket_type=='酷券'"
            v-b-tooltip.hover
            :title="row.item.store_score_remark"
            :show-rating="false"
            @rating-selected="updateStoreRating(row.item)"
          ></star-rating>
          <b-button v-if="$bus.getRole()!='admin'&&row.item.user_scored" disabled>用戶已評分</b-button>
          <span v-if="$bus.getRole()=='admin'&&row.item.user_score>0">用戶已評{{row.item.user_score}}分</span>
          <span v-if="$bus.getRole()=='admin'&&row.item.store_score>0">店家已評{{row.item.store_score}}分</span>
          <b-button v-if="$bus.getRole()==='admin'&&lockIconIndex&&filterOptions[lockIconIndex].btnIcon==='unlock'&&['sys_admin','support_mgr','support'].includes($bus.session.role_type)" size="sm" @click.stop="showCancelExec(row)" class="mr-1">
            手動取消核銷
          </b-button>

        </template>
      </b-table>
    </div>
    <b-modal
      id="cancelExecCfm"
      ref="cancelExecFrm"
      size="md"
      v-model="modalCancelShow"
      centered
      title="取消核銷"
      hide-footer
    >
      <b-form>
        <b-row class="mt-1">
          <span class="col-3">票號</span>
          <b-form-input class="col-6" type="text" disabled v-model="cancelTicketNo"></b-form-input>
          <span class="col-3"></span>
        </b-row>
        <b-row class="mt-1">
          <span class="col-3">備註</span>
          <b-form-textarea class="col-8" :rows="3" v-model="confirmCancelRemark" placeholder="請輸入取消原因描述"></b-form-textarea>
        </b-row>
        <b-row class="mt-1">
          <span class="col-3"></span>
          <b-button class="col-2" @click="modalCancelShow=false">取消</b-button>
          <span class="col-2"></span>
          <b-button class="col-2" @click="confirmCancel">確認</b-button>
          <span class="col-3"></span>
        </b-row>
      </b-form>
    </b-modal>
    <b-modal
      id="storeScorePopup"
      ref="storeScorePopup"
      size="md"
      v-model="modalStoreScoreShow"
      centered
      hide-header
      hide-footer
    >
      <b-form class="scoring-modal">
        <b-row class="mt-1">
          貴店對此用戶“ {{scoringItem.user_name}} ”於{{scoringItem.ticket_scan_time}}到店的 {{scoringItem.service_name}} 評價為：
        </b-row>
        <b-row class="mt-1">
          <star-rating
            v-model="scoringItem.store_score"
            :starSize=30
            :show-rating="true"
            style="margin-left:25%;"
          ></star-rating>
        </b-row>
        <b-row class="mt-1">
          <span class="col-3">備註</span>
          <b-form-textarea class="col-8" :rows="3" v-model="scoringItem.store_score_remark" placeholder="可輸入評分備註"></b-form-textarea>
        </b-row>
        <b-row class="mt-1">
          <span class="col-3"></span>
          <b-button class="col-2" @click="cancelUpdateScore">取消</b-button>
          <span class="col-2"></span>
          <b-button class="col-2" @click="confirmUpdateScore">確認</b-button>
          <span class="col-3"></span>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>

import { 
  apiListToExcel,
  apiDownloadFile
 } from '@/api/Util.js'

import {
  apiGetMerchantAutoComplete,
  apiGetMerchantById,
  apiCancelServiceExecution
} from '@/api/AdminManage.js'

import {
  apiGetExecutionEventList 
} from '@/api/Merchant.js'

import axios from 'axios'

export default {
  name: 'ServiceExecutionList',
  components: {

  },
  data: function () {
    return {
      modalCancelShow:false,
      modalStoreScoreShow:false,
      scoringItem:{},
      cancelTicketNo:"",
      lockIconIndex:-1,
      cnacelIndex: -1,
      cancel_execution_id:-1,
      confirmCancelRemark:"",
      filterData: {
        SelectedMerchantItem: null,
        selectedStore: null,
        selectedServiceItem: null,
      },
      filterOptions:[
        {
          'componentType':'span',
          'placeholder':'供應商',
          'col':2,
          'hide':this.$bus.getRole()!=='admin',
        },
        {
          'componentType':'vue-single-select',
          'optionVar':'Merchants',
          'defaultValue':null,
          'akey':'SelectedMerchantItem',
          'asyncFetchCB': this.loadMerchantByKeyword,
          'optionLabel':'merchant_full_name',
          'col':10,
          'placeholder':'指定供應商查看',
          'title':'切換選擇即更新下方顯示,選擇任一供應商後才顯示',
          'hide':this.$bus.getRole()!=='admin',
        },
        {
          'componentType':'b-form-select',
          'optionVar':'Stores',
          'defaultValue':null,
          'akey':'selectedStore',
          'optionLabel':'store_name',
          'col':6,
          'placeholder':this.$bus.getRole()==='admin'?"選擇分店":'',
          'hide':(this.$bus.getRole()!=='admin' && (this.$bus.session.is_super_manage?false:true)),
        },
        {
          'componentType':'text',
          'defaultValue':'',
          'akey':'ticket_no',
          'col':6,
          'placeholder':'輸入AA票號(只查詢一張票的核銷)',
          'hide':(this.$bus.getRole()!=='admin' && (this.$bus.session.is_super_manage?false:true)),
          execCallback:this.GoSearch,
        },
        {
          'componentType':'b-form-select',
          'optionVar':'Services',
          'defaultValue':null,
          'akey':'selectedServiceItem',
          'optionLabel':'service_name',
          'col':6,
          'placeholder':this.$bus.getRole()==='admin'?"選擇課程":'',
        },
        {
          'componentType':'date-picker',
          'akey':'QueryStartDate',
          'defaultValue':null,
          'col':3,
          'placeholder':"篩選時段日期起",
          'title':"篩選時段日期起：若指定將排除此日期之前的核銷紀錄",
        },
        {
          'componentType':'date-picker',
          'akey':'QueryEndDate',
          'defaultValue':null,
          'col':3,
          'placeholder':"篩選時段日期迄",
          'title':"篩選時段日期迄：若指定將排除此日期之後的核銷紀錄",
        },
        {
          'componentType':'text',
          'akey':'QueryKeyword',
          'defaultValue':'',
          'col':2,
          'placeholder':"購票者姓名篩選",
          'title':"若輸入則模糊比對購票者姓名",
          execCallback:this.GoSearch
        },
        {
          'componentType':'b-form-select',
          'akey':'TicketType',
          'dataOptions':[{text:'全部票券類型',value:''},{text:'電子',value:'electronic'},{text:'紙本',value:'paper'},{text:'line酷券',value:'line'}],
          'defaultValue':'',
          'col':2,
          'placeholder':"篩選票券類型",
        },
        {
          'componentType':'b-button',
          'akey':'button1',
          'col':2,
          'placeholder':"查詢",
          'execCallback':this.GoSearch,
        },
        {
          'componentType':'b-button',
          'akey':'button2',
          'col':2,
          'placeholder':"下載報表",
          'execCallback':this.downloadReport,
        },        
        {
          componentType:'b-button',
          col:1,
          akey:'showForceCancel',
          btnIcon:'lock',
          title:'點擊解鎖後才可以手動取消核銷',
          hide:this.$bus.getRole()!=='admin',
          execCallback:this.switchLock
        },
        {
          'componentType':'span',
          'col':1,
          'placeholder':'符合總筆數',
          'defaultValue':''
        },
        {
          'componentType':'text',
          'akey':'result_total',
          'col':2,
          'disabled':true,
          'defaultValue':'尚未查詢'
        },
      ],
      showFilter: true,
      datePicketOptions: {
        format: 'YYYY/MM/DD',
        useCurrent: false,
      },
      fields: [
        {
          key: 'user_name',
          label: '購票者',
          sortable: false
        },
        {
          key: 'ticket_scan_time',
          label: '到店時間',
          sortable: false
        },
        {
          key: 'store_name',
          label: '分店',
          sortable: false
        },
        {
          key: 'service_name',
          label: '課程',
          sortable: false
        },
        {
          key: 'ticket_no',
          label: '票號',
          sortable: false
        },
        {
          key: 'ticket_id',
          label: 'TN票號',
          sortable: false
        },
        {
          key: 'ticket_type',
          label: '類型',
          sortable: false
        },
        {
          key: 'apply_pf',
          label: '當前請款單',
          sortable: false
        },
        {
          key: 'actions',
          label: (this.$bus.getRole()==='merchant'||this.$bus.getRole()==='merchant')?'對用戶評價':'',
          sortable: false
        },
      ],
      dismissSecs: 1,
      dismissCountDown: 0,
      modalShow: false,
      Merchants: [],
      SelectedMerchantId: null,
      SelectedMerchantItem: Object,
      SelectedMerchant: Object,
      CachedMerchant: Object, //用merchant_id當key的merchant_info cache
      CachedLoginStores: Object, //用merchant_store_id當key的merchant_store login cache
      Stores: [],
      SelectedStoreId: null,
      SelectedStoreAccount: '',
      Services: [],
      SelectedServiceId: null,
      isLoading:false,
      pageNumber:0,
      itemsPerPage:50,
      hasMore:true,
      QueryExecutionListResult: [],
      downloadReportFilter:{},
    }
  },
  props: [

  ],
  methods: {
    async downloadReport() {

      // 刪掉頁碼的欄位就能取到所有資料
      delete this.downloadReportFilter.page_number
      delete this.downloadReportFilter.items_per_page

      let Param = this.downloadReportFilter
      let vm = this

      // 取資料
      let results = await apiGetExecutionEventList(Param).then(function(resp){
        let data = resp.data
        let execution_events = []

        if (data.data.executionEvents) {
          execution_events = data.data.executionEvents
        }
        else {
          execution_events = data.data.executionExents
        }

        return execution_events
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return []
        }
        return []
      })
      // 沒資料就不過
      if (results.length === 0) {
        this.$bus.fnShowInfo('無資料可以下載')
        return
      }

      console.log(results)

      // 轉成array變成excel
      let map_execution_events = []
      results.forEach(function(event){
        let tmp = {}
        vm.fields.forEach(function(field){
          
          tmp[field.label] = event[field.key]
          
        })
        map_execution_events.push(tmp)
      })

      let params = {
        "source":map_execution_events
      }

      // 拿到下載網址
      let result = await apiListToExcel(params).then(function(resp){
        return resp
      })

      // 下載檔案，取代前綴路徑然後加上網域
      let download_url = ''
      download_url = process.env.VUE_APP_API_ENDPOINT + result.data.data.url.replace('/api/ticket', '')

      let file_name = vm.filterData.QueryStartDate + '_' + vm.filterData.QueryEndDate + '_' 

      if (vm.filterData.SelectedMerchantItem !== null) {
        file_name += vm.filterData.SelectedMerchantItem.merchant_full_name
      }

      // 實際下載檔案
      apiDownloadFile(download_url).then(function(resp){
        const url = window.URL.createObjectURL(new Blob([resp.data], {type:'application/vnd.ms-excel'}));
        const link = document.createElement('a');

        link.href = url;
        link.setAttribute('download', file_name + '.xlsx');
        document.body.appendChild(link);
        link.click();
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return 
        }
      })
    },
    switchLock() {
      this.filterOptions[this.lockIconIndex].btnIcon = this.filterOptions[this.lockIconIndex].btnIcon==='lock'?'unlock':'lock'
      this.$refs.filterForm.refreshModelVar('showForceCancel')
    },
    updateStoreRating(item) {
      this.scoringItem = this.CpObj(item)
      this.modalStoreScoreShow = true
    },
    cancelUpdateScore() {
      //理論上可以找到原本那筆把評分恢復到之前的狀態...但十分複雜(點了v-model就變了啊)
      //先簡單reload吧
      this.loadExecutionList()
      this.modalStoreScoreShow=false
    },
    confirmUpdateScore() {
      let Param = {
        'module':'work_site',
        'method':'enter_serviceLog',
        'service_execution_id':this.scoringItem.service_execution_id,
        'score':this.scoringItem.store_score,
        'remark': this.scoringItem.store_score_remark,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            //很悲劇也要重撈讓剛點的分數恢復正確的值
            vm.loadExecutionList()
            return
        }
        //直接把刪除的那個index拿掉
        vm.$bus.fnShowInfo('已更新對用戶的評分')
        vm.modalStoreScoreShow = false
        vm.loadExecutionList()
      }, this)
    },
    showCancelExec(row) {
      //取消核銷,popup,如果popup裡確認呼叫api且成功則需要reload列表
      this.confirmCancelRemark = ""
      this.cancel_execution_id = row.item.service_execution_id
      this.cancelTicketNo = row.item.ticket_no
      this.cnacelIndex = row.index
      this.modalCancelShow = true
    },
    confirmCancel() {
      let Param = {
        'module':'admin_manage',
        'method':'cancelServiceExecution',
        'service_execution_id':this.cancel_execution_id,
        'force_normal_cancel':1,
        'cancel_remark': this.confirmCancelRemark,
      }
      let vm = this
      apiCancelServiceExecution(Param).then(function(resp){
        let data = resp.data
        //直接把刪除的那個index拿掉
        vm.QueryExecutionListResult.splice(vm.cnacelIndex,1)
        vm.$bus.fnShowInfo('已完成取消')
        vm.modalCancelShow = false  
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
        }
      })
      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //       vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
      //       return
      //   }
      //   //直接把刪除的那個index拿掉
      //   vm.QueryExecutionListResult.splice(vm.cnacelIndex,1)
      //   vm.$bus.fnShowInfo('已完成取消')
      //   vm.modalCancelShow = false  
      // }, this)
    },
    handleScroll(evt) {
      // 不要scroll到底時一次瞬間觸發好幾次載入
      if (this.calScrollRatio(evt) > 0.95) {
        setTimeout(() => {
          this.$refs.scrollarea.$emit('scrolldownend')
        }, 500);
      }
    },
    optionValueChanged(upd) {
      if (upd.key === 'SelectedMerchantItem') {
        this.SelectedMerchant = upd.val
        if (upd.val && upd.val.merchant_id) {
          this.loadMerchantById(upd.val.merchant_id)
        }
        else {
          this.filterData.selectedStore = null
          this.filterData.selectedServiceItem = null
          this.Stores = []
          this.Services = []
          this.$refs.filterForm.refreshModelVar()
        }
      }
      else if (upd.key === 'selectedStore') {
        this.SelectedStoreId = upd.val?upd.val.id:null
      }
      else if (upd.key === 'selectedServiceItem') {
        this.SelectedServiceId = upd.val?upd.val.ticket_project_id:null
      }
      if (['SelectedMerchantItem','selectedStore','selectedServiceItem','TicketType'].includes(upd.key)) {
        setTimeout(() => {
          this.GoSearch()
        }, 200);
      }
    },
    GoSearch () {
      this.loadExecutionList()
    },
    loadExecutionList (append=false) {
      if (this.isLoading) {
        return
      }
      if (append === true) {
        if (!this.hasMore) {
          return
        }
        this.pageNumber ++
      }
      else {
        this.pageNumber = 1
        this.hasMore = true
        this.$refs.wrapper.scrollTop = 0
      }
      let vm = this
      let Param = {
        'module':'merchant',
        'method':'getExecutionEventList',
        'merchant_id':vm.filterData.SelectedMerchantItem?vm.filterData.SelectedMerchantItem.merchant_id:0,
        'merchant_store_id':vm.filterData.selectedStore?vm.filterData.selectedStore.merchant_store_id:0,
        'merchant_service_id': vm.filterData.selectedServiceItem?vm.filterData.selectedServiceItem.merchant_service_id:0,
        'view_start_date':vm.filterData.QueryStartDate?vm.filterData.QueryStartDate:'',
        'view_end_date':vm.filterData.QueryEndDate?vm.filterData.QueryEndDate:'',
        'keyword':vm.filterData.QueryKeyword,
        'ticket_no':vm.filterData.ticket_no?vm.filterData.ticket_no:'',
        'ticket_type':vm.filterData.TicketType,
        'page_number':this.pageNumber,
        'items_per_page':this.itemsPerPage,
      }
      this.downloadReportFilter = JSON.parse(JSON.stringify(Param))
      this.isLoading = true
      
      apiGetExecutionEventList(Param).then(function(resp){
        let data = resp.data
        // eslint-disable-next-line
        // append (排序有助於之後找出起訖日期的最早時間,但動態改options.scrollTime沒用,就先不做)
        if (vm.pageNumber === 1) {

          if (data.data.executionEvents){
            vm.QueryExecutionListResult = data.data.executionEvents
          }
          else {
            vm.QueryExecutionListResult = data.data.executionExents
          }
          
          vm.filterData.result_total = data.data.total
          // 這裡超雷,vue-single-select用asyncFetchCB方式處理的,refreshModelVar()全部會被reset
          vm.$refs.filterForm.refreshModelVar('result_total')
        }
        else {

          if (data.data.executionEvents) {
            vm.QueryExecutionListResult = vm.QueryExecutionListResult.concat(data.data.executionEvents)
          }
          else {
            vm.QueryExecutionListResult = vm.QueryExecutionListResult.concat(data.data.executionExents)
          }
        }
        if (!data.data.hasMore) {
          vm.hasMore = false
        }
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
        }
      })
      vm.isLoading = false

      // vm.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //       vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
      //       return
      //   }
      //   // eslint-disable-next-line
      //   // append (排序有助於之後找出起訖日期的最早時間,但動態改options.scrollTime沒用,就先不做)
      //   if (vm.pageNumber === 1) {
      //     vm.QueryExecutionListResult = data.data.executionEvents
      //     vm.filterData.result_total = data.data.total
      //     // 這裡超雷,vue-single-select用asyncFetchCB方式處理的,refreshModelVar()全部會被reset
      //     vm.$refs.filterForm.refreshModelVar('result_total')
      //   }
      //   else {
      //     vm.QueryExecutionListResult = vm.QueryExecutionListResult.concat(data.data.executionEvents)
      //   }
      //   if (!data.data.hasMore) {
      //     vm.hasMore = false
      //   }
      //   setTimeout(() => {
      //     vm.isLoading = false
      //   }, 500);
      // },vm)
    },
    loadMerchantByKeyword (keyword) {
      if (!keyword) {
        // 有填至少一個關鍵字才回傳選項
        this.Merchants = []
        return
      }
      let Param = {
        'module':'admin_manage',
        'method':'getMerchantAutoComplete',
        'keyword':keyword,
      }
      let vm = this
      apiGetMerchantAutoComplete(Param).then(function(resp){
        let data = resp.data
        vm.Merchants = data.data.matched_merchant_list
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
        }
      })
      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //       vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
      //       return
      //     }
      //     vm.Merchants = data.data.matched_merchant_list
      // },this)
    },
    loadMerchantById(merchant_id) {
      // 回到預設(event也應清掉,都換檢視供應商了)
      this.QueryExecutionListResult = []
      this.Stores = []
      this.Services = []
      if (!merchant_id) {
        this.filterData.SelectedMerchantItem = null
        this.filterData.selectedStore = null
        this.filterData.selectedServiceItem = null
        return
      }
      // 先判斷cache
      if (this.CachedMerchant.hasOwnProperty('m_'+merchant_id)) {
        this.Stores = this.CachedMerchant['m_'+merchant_id].merchant_stores
        this.Services = this.CachedMerchant['m_'+merchant_id].merchant_ticket_projects
        return
      }
      else {
        this.FocusedMerchantId = merchant_id
        // 再抓資料庫放cache
        let Param = {
          'module':'admin_manage',
          'method':'get_merchant_by_id',
          'merchant_id':merchant_id,
        }
        let vm = this
        apiGetMerchantById(Param).then(function(resp){
          let data = resp.data
          // eslint-disable-next-line
          data.data.merchant_stores = vm.parseAdminStores(data.data.merchant_stores)
          vm.Stores = data.data.merchant_stores
          let services = []
          for (let i=0;i<data.data.merchant_ticket_projects.length;i++) {
            let item = {
                ticket_project_service_item_id:data.data.merchant_ticket_projects[i].ticket_services[0].ticket_project_service_item_id,
                ticket_project_id:data.data.merchant_ticket_projects[i].id,
                merchant_service_id:data.data.merchant_ticket_projects[i].ticket_services[0].merchant_service_id,
                service_name:data.data.merchant_ticket_projects[i].ticket_services[0].service_name,
                product_id:data.data.merchant_ticket_projects[i].product_id
            }
            services.push(item)
          }
          //為了cache的值狀態更新
          data.data.merchant_ticket_projects = services
          // vm.SelectedMerchantItem.merchant_ticket_projects = services
          vm.Services = services
          vm.CachedMerchant['m_'+vm.FocusedMerchantId] = data.data
          vm.isLoading = false
        }).catch(function(error){
          let data = error.response.data
          if (data.ok === 0) {
              vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
              vm.isLoading = false
            return
          }
        })
        // this.$bus.apiCall(Param, function (data, vm) {
        //   if (data.ok === 0) {
        //       vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
        //       vm.isLoading = false
        //     return
        //   }
        //   // eslint-disable-next-line
        //   data.data.merchant_stores = vm.parseAdminStores(data.data.merchant_stores)
        //   vm.Stores = data.data.merchant_stores
        //   let services = []
        //   for (let i=0;i<data.data.merchant_ticket_projects.length;i++) {
        //     let item = {
        //         ticket_project_service_item_id:data.data.merchant_ticket_projects[i].ticket_services[0].ticket_project_service_item_id,
        //         ticket_project_id:data.data.merchant_ticket_projects[i].id,
        //         merchant_service_id:data.data.merchant_ticket_projects[i].ticket_services[0].merchant_service_id,
        //         service_name:data.data.merchant_ticket_projects[i].ticket_services[0].service_name,
        //         product_id:data.data.merchant_ticket_projects[i].product_id
        //     }
        //     services.push(item)
        //   }
        //   //為了cache的值狀態更新
        //   data.data.merchant_ticket_projects = services
        //   // vm.SelectedMerchantItem.merchant_ticket_projects = services
        //   vm.Services = services
        //   vm.CachedMerchant['m_'+vm.FocusedMerchantId] = data.data
        //   vm.isLoading = false
        // },this)
      }
    },
    parseAdminStores(stores) {
      let parsed_stores = []
      for (let i=0;i<stores.length;i++) {
        let store = stores[i]
        store.merchant_store_id = store.id
        delete store['id']
        parsed_stores.push(store)
      }
      return parsed_stores
    },
  },
  computed: {
    
  },
  created: function () {
    if (!this.$bus.session) {
      // 要重登入
      this.$bus.session = undefined
    }
    // 設定鎖頭按鈕的索引
    for (let i=0;i<this.filterOptions.length;i++) {
      if (this.filterOptions[i].akey === 'showForceCancel') {
        this.lockIconIndex = i
        break
      }
    }
  },
  mounted () {
    // 先關閉載入資料,否則四個切換控件初始化就會瞬間呼叫四次同樣api
    this.isLoading = true
    this.$refs.filterForm.initDefault()
    setTimeout(() => {
      this.isLoading = false
    }, 1000);
    if (this.$bus.session && this.$bus.session != 'undefined' && (this.$bus.getRole() === 'merchant' || this.$bus.getRole() === 'spalogin' )) {
      let myMerchant = {
        'merchant_id': this.$bus.session.merchant_id,
        'merchant_name': this.$bus.session.merchant_name,
      }
      this.Merchants.push(myMerchant)
      this.filterData.SelectedMerchantItem = myMerchant
      this.SelectedMerchantId = this.$bus.session.merchant_id
      this.Stores = this.CpObj(this.$bus.session.stores)
      if (this.Stores.length > 1) {
        this.Stores.unshift({'store_name':'全部分店','merchant_store_id':0})
      }
      this.filterData.selectedStore = this.Stores[0]
      let service_items = []
      for (let i=0;i<this.$bus.session.ticket_projects.length;i++) {
        service_items.push({
          'merchant_service_id': this.$bus.session.ticket_projects[i].service_items[0].merchant_service_id,
          'service_name':this.$bus.session.ticket_projects[i].service_items[0].service_name
        })
      }
      this.Services = service_items
      if (this.Services.length > 1) {
        this.Services.unshift({'service_name':'選擇課程','merchant_service_id':0})
      }
      this.filterData.selectedServiceItem = this.Services[0]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wrapper2 {
  height: 58vh;
  overflow-y: scroll;
  border-style: inset;
}
.scoring-modal {
  background-color:cornsilk;
  padding-left: 5%;
  padding-right: 5%;
}
</style>
